/**
 * classroomApi.js
 * ----------------
 * API client for Classrooms Master using centralized createMasterApiClient.
 * Connects directly to FastAPI backend /classrooms/ and /options/branches endpoints.
 */
import { createMasterApiClient } from '../../common/masterApiFactory';
import api from '../../../../api/client';

const classroomsClient = createMasterApiClient('classrooms');

export async function listClassrooms(params = {}) {
  return await classroomsClient.list(params);
}

export async function getClassroomDetail(classroomId) {
  return await classroomsClient.getById(classroomId);
}

export async function createClassroom(payload) {
  return await classroomsClient.create(payload);
}

export async function updateClassroom(classroomId, payload) {
  return await classroomsClient.update(classroomId, payload);
}

export async function archiveClassroom(classroomId) {
  return await classroomsClient.archive(classroomId);
}

export async function deleteClassroom(classroomId) {
  return await classroomsClient.remove(classroomId);
}

export async function getClassroomOptions(branchId = null) {
  const params = branchId ? { branchId } : {};
  const response = await api.get('/classrooms/options', { params });
  return response.data;
}

export async function getBranchOptions() {
  try {
    const response = await api.get('/options/branches');
    return response.data || [];
  } catch (err) {
    // Fallback to /branches/ if /options/branches is unavailable
    const fallback = await api.get('/branches/');
    const list = fallback.data?.items || fallback.data || [];
    return list.map(b => ({
      value: String(b.id),
      label: b.name || b.branch_code || `Branch #${b.id}`,
    }));
  }
}
